import { createContext as l, useContext as m } from "react";
function f(r, t) {
  return `${r} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function p(r = {}) {
  const {
    name: t,
    strict: s = !0,
    hookName: i = "useContext",
    providerName: x = "Provider",
    errorMessage: n,
    defaultValue: d
  } = r, e = l(d);
  e.displayName = t;
  function a() {
    var c;
    const u = m(e);
    if (!u && s) {
      const o = new Error(
        n ?? f(i, x)
      );
      throw o.name = "ContextError", (c = Error.captureStackTrace) == null || c.call(Error, o, a), o;
    }
    return u;
  }
  return [e.Provider, a, e];
}
export {
  p as c
};
//# sourceMappingURL=index-226b8ea6.js.map
